import { combineReducers } from '@reduxjs/toolkit';
import offer from './offer';

const root = combineReducers({
  offer,
});

export default root;
